import { CardEmptyLegDetail } from "./desktop";
import { CardEmptyLegDetailMobile } from "./mobile";

export { CardEmptyLegDetail, CardEmptyLegDetailMobile };
